import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API, environment } from '@core/envs';
import { IResponseModel } from '@core/interface';

const BASE_URL = `${environment.getRoute(API.owners)}/vehicles`;

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private http: HttpClient) { }

  getVehicleImage(vin: string, country: string): Observable<IResponseModel<string>> {
    const url = `${BASE_URL}/${vin}/images?country=${country}`;
    return this.http.get<IResponseModel<string>>(url);
  }
}
